import loadable from '@loadable/component';

// 懒加载组件
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));
const InventoryDetailQuery = loadable(() => import('./inventoryDetailQuery/InventoryDetailQuery'));
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));
const DeliveryProgressQuery = loadable(() => import('./deliveryProgressQuery/DeliveryProgressQuery'));
const HospitalGroupInventoryQuery = loadable(() => import('./hospitalGroupInventoryQuery/HospitalGroupInventoryQuery'));
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));
const InvoiceInformationQuery = loadable(() => import('./invoiceInformationQuery/InvoiceInformationQuery'));

export const subRoutes = [
  {
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  },
  { // M846255003库存余额明细查询
    path: '/InventoryDetailQuery',
    component: InventoryDetailQuery
  },
  {
    // M846258005: 供应商：发票上交申请管理
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    // M258005: 供应商：发票上交申请管理发票编辑
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  },
  {
    // M846252003: 发货进度查询(上海金山)
    path: '/DeliveryProgressQuery',
    component: DeliveryProgressQuery
  },
  {
    path: '/HospitalGroupInventoryQuery',
    component: HospitalGroupInventoryQuery
  },
  {
    // 846258002销售结算对账单
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  },
  {
    //846258006 发票信息查询
    path: '/InvoiceInformationQuery',
    component: InvoiceInformationQuery
  }
];
